export default function CEProductPreviewer({ selectedProduct, children }) {
  if (!selectedProduct) {
    return (
      <div className="product-info">
        <h3>Product Preview</h3>
        <p>Select a product to see the preview</p>
      </div>
    );
  }

  return (
    <div className="product-info">
      <div className="img-container">
        {selectedProduct.images[0] && (
          <img className="product-img" src={selectedProduct.images[0].url} alt={selectedProduct.title} />
        )}
        {children}
      </div>
    </div>
  );
}
